import styles from './style.postcss';
import React from 'react';
import classnames from 'classnames';
import { pure } from 'recompose';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

const Row = ({ stripe, children, className }) => <tr className={classnames(
      styles.SimpleTable_row,
      testClass('table-row'),
      className,
      { [styles.__stripe]: !! stripe }
    )}>
  {children}
</tr>;

Row.propTypes = {
  stripe: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.node,
};

export default pure(Row);



// WEBPACK FOOTER //
// ./components/SimpleTable/Row.jsx